import React from 'react';

export interface AccordionGroupProps {
  children?: React.ReactNode;
  className?: string;
}

export const AccordionGroup: React.FC<AccordionGroupProps> = ({ children, className = '' }) => {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--spacing-xs)',
        marginBlock: 'var(--spacing-md)',
      }}
    >
      {children}
    </div>
  );
};

export default AccordionGroup;
